import { render, staticRenderFns } from "./CardSessions.vue?vue&type=template&id=37e36bae&"
import script from "./CardSessions.vue?vue&type=script&lang=js&"
export * from "./CardSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports